module.exports = "/images/paypal.svg?e2ca5c2542088541278a40d43d12644b";